import {createContext} from "react"

export const store = createContext(null);
export const initialState = {
    users:[],
    progress:false,
    dialog:false,
    search:{
        firstName:'',
        lastName:'',
        nationalCode:'',
        mobilePhone:'',
        company:'',
        companyNationalCode:'',
        role:['customer','driver']
    },
    results:null,
    page:1,
    limit:20
}
export function reducer(state,actions){
    const {payload,type} = actions;
    switch (type) {
        case 'ADD_USER':
            return {...state,users:[...state.users,payload]};
        case 'REMOVE_USER':
            return {...state,users:state.users.filter(user=>user._id!==payload)};
        case 'REMOVE_ALL_USERS':
            return {...state,users:[]}
        case 'OPEN_DIALOG':
            return {...state,dialog:true};
        case 'CLOSE_DIALOG':
            return {...state,dialog:false};
        case 'CHANGE_SEARCH_TEXT_FIELD':
            return {...state,search:{...state.search,[payload.name]:payload.value}}
        case 'CHANGE_ROLE':
            return {...state,search:{...state.search,role:payload}}
        case 'PROGRESS':
            return {...state,progress:payload};
        case 'PAGE':
            return {...state,page:payload};
        case 'RESULTS':
            return {...state,results:payload};
        default:
            return {...state};
    }
}